import { Box, Flex, Text, Switch } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { useFormContext } from './FormCustomer'
export function IdVerifyAt() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const form = useFormContext()
  const verified = form.getInputProps('id_verified_at').value
  return (
    <Box mb='lg'>
      <Flex mt='md' mb='xs' align='center'>
        <Box style={{ flex: 1 }}>
          <Flex direction='column'>
            <Text fw={'500'}>{t('add_customer.id_verify')}</Text>
            <Text c={'gray'} size={'sm'} fs='sm'>
              {t('add_customer.id_verify_description')}
            </Text>
          </Flex>
        </Box>
        <Switch
          checked={verified}
          onChange={() =>
            form.setFieldValue('id_verified_at', verified ? '' : 'on')
          }
        />
      </Flex>
    </Box>
  )
}
